import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import packageJson from '../../../../../package.json';
import { Subscription } from 'rxjs';
import { ProjectContextService } from '@services/project-context/project-context.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnDestroy {
  public version: string = (packageJson as { version?: string }).version || '';
  public showPstdLogos = false;
  private readonly subscriptions = new Subscription();

  constructor(
    private router: Router,
    private projectContext: ProjectContextService
  ) {
    this.subscriptions.add(
      this.projectContext.selectedProjectId$.subscribe((projectId) => {
        this.showPstdLogos = (projectId || '').trim().toUpperCase() === 'AYUNTUI01';
      })
    );
  }

  goToLegalDiscalimer() {
    this.router.navigate(['/legal-disclaimer']);
  }

  goToCookiePolicy() {
    this.router.navigate(['/cookie-policy']);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
